module.exports = function(app) {

    app.directive('manageSpendingAccountSection', ['sessionData', function(sessionData) {
        return {
            //restrict: 'E',
            //template: require('directives/spending/manageSpendingAccountSection.html'),
            templateUrl: 'spending.appTemplate.html/chmhom/directives/spending/manageSpendingAccountSection',
            scope: {
                accountTypes:"="
            },
            replace:true,
            link: function(scope){

            },
            controller: 'directive.spending.manageSpendingAccount'
        };
    }]);

    app.controller("directive.spending.manageSpendingAccount", ["$scope", "session","services", "storage","coremetrics","sessionData","spendingAccountsService","$q","$cookies","$timeout","spaUtil","dataManager",
        function( $scope, session,services, storage,coremetrics,sessionData,spendingAccountsService,$q,$cookies ,$timeout,spaUtil,dataManager){
            $scope.errorMsg = "no data";
            $scope.glanceAccountList={};
            $scope.accountDisplayList =[];
            var accountTypes =  $scope.accountTypes || [];

            $scope.viewState = 'loading';



            var
                memberInfo = sessionData.memberInfo,
                clientNumberList = spendingAccountsService.spendingAccountClients(memberInfo);



            spendingAccountsService.getAllAmountsAndGlances().then(function (response) {

                var hasSpendingAccount =    spendingAccountsService.hasSpendingAccount(response);
                if(!hasSpendingAccount){
                    $scope.errorMsg =  "You currently have no active spending accounts";
                    $scope.viewState = 'error';
                }else{
                    dataManager.getCompleteAccountInfo(response).then(function(results){
                        if(results.tempCompleteData ){
                            var accountDisplayList =  displayAccountData(results.tempCompleteData,results.claimAmountData);
                            console.log("accountDisplayList"+JSON.stringify(accountDisplayList));
                            if(accountDisplayList){
                                $scope.viewState = 'success';
                                $scope.accountDisplayList=accountDisplayList;
                            }
                        }
                    });


                }
            },function(){
                $scope.errorMsg = "Spending Account is currently not available. Please try again later.";
                $scope.viewState = 'error';

            });



            var displayAccountData = function(completeAccountData,claimAmountData,glanceData){
                var accountCompleteData = null;
                var partialLoad = false;
                var accountDisplayList = [];
                if(completeAccountData && completeAccountData.length>0){
                    accountCompleteData = angular.copy(completeAccountData);
                    accountCompleteData.forEach(function(accountData){
                        var electionStartDate = "";
                        var electionEndDate = "";
                        var accountBalanceTotal = 0;

                        var accountCounter = 0;
                        var investmentCounter = 0;

                        var electionStartObject = [];
                        var electionEndObject = [];
                        var grandAccountBalance = 0;
                        var planYearType = {};
                        var earliestDate = new Date();
                        var latestDate = new Date();

                        var displayDataObject = {
                            'displaySeq' :spaUtil.getHmAccountDisplaySeq(accountData.accountType,accountTypes),
                            'groupCode': accountData.groupCode,
                            'employerName': spaUtil.getClientName(accountData.groupCode),
                            'accountType' : spaUtil.getHmAccountTypes(accountData.accountType, "shortCode", accountData.groupCode,accountTypes),
                            'accountName' : spaUtil.getHmAccountTypes(accountData.accountType, "accountDescription", accountData.groupCode,accountTypes),
                            'numTransactions' : accountData.transactionCount,
                            //'investmentBalance' : spaUtil.convertCurrency(accountData.electionList[0].investmentBalance),
                            'transactionRange' : "30",
                            //'electionList': this.sortElectionList(accountData.electionList),
                            //'accountOptionList': accountData.accountOptionList
                            'detailLoading' : true
                        };
                        if (!partialLoad) {
                            displayDataObject.investmentBalance = accountData.electionList[0].investmentBalance || '0.00';
                            displayDataObject.accountOptionList = accountData.accountOptionList;
                            displayDataObject.electionList = sortElectionList(accountData.electionList);
                            // CR00474974_Cancelled-Inactive FSA presenting before active HSA - Display cancelled/inactive account after Active accounts
                            displayDataObject.displaySeq = spaUtil.getFinalHmAccountDisplaySeq(accountData.accountType,displayDataObject.displaySeq,accountData.electionList);
                            displayDataObject.detailLoading = false;
                        }

                        // Get account balance from the GetClaimAmountService response
                        for (var y in claimAmountData) {
                            if (claimAmountData[y].accountTypeCode == accountData.accountType) {
                                grandAccountBalance=Number(claimAmountData[y].currentBalance);

                                break;
                            }
                        }
                        displayDataObject.accountBalance = grandAccountBalance || '';

                        for (var x in displayDataObject.electionList ) {

                            if ( accountData.accountType == "HSA" ) {

                                var availableBalance = displayDataObject.electionList[x].currentBalance - displayDataObject.electionList[x].totalPending;
                                displayDataObject.electionList[x].availableBalance = availableBalance;
                                displayDataObject.electionList[x].totalContribution = displayDataObject.electionList[x].totalContribution || '0.00';
                                displayDataObject.electionList[x].sinceYear = displayDataObject.electionList[x].beginDate;

                                var investmentBalance = displayDataObject.electionList[x].investmentBalance ? displayDataObject.electionList[x].investmentBalance : '0.00';
                                displayDataObject.electionList[x].investmentBalance = investmentBalance || '0.00';


                            }
                            else {

                                displayDataObject.electionList[x].goalAmount = displayDataObject.electionList[x].goalAmount || '0.00';
                                displayDataObject.electionList[x].totalDenied = displayDataObject.electionList[x].totalDenied || '0.00';
                            }
                            //must come AFTER the above calculations, otherwise, their values are non parseable string values like '$0.00'
                            displayDataObject.electionList[x].totalPending = displayDataObject.electionList[x].totalPending || '0.00';
                            displayDataObject.electionList[x].currentBalance = displayDataObject.electionList[x].currentBalance || '0.00';
                            displayDataObject.electionList[x].totalPaid = displayDataObject.electionList[x].totalPaid || '0.00';

                        }
                        var firstTimeThroughElection = 0;
                        if (!partialLoad) {
                            for(var electionIteration = 0; electionIteration <= accountData.electionList.length-1; electionIteration++)
                            {

                                if(firstTimeThroughElection === 0) {
                                    firstTimeThroughElection = 1;
                                }
                                //lidr9hl-adding plantype assuming possible multiple plan type or all
                                planYearType[accountData.electionList[electionIteration].planYearType] = true;

                                /*}*/
                            }
                        }
                        displayDataObject.planYearType = planYearType;
                        accountDisplayList.push(displayDataObject);
                    });
                    accountDisplayList = sortAccountsForDisplay(accountDisplayList);
                    if (accountDisplayList[0]) {
                        accountDisplayList[0].isOpen = true;
                    }
                }/*else{
                    accountCompleteData = angular.copy(glanceData);
                    partialLoad = true;
                }*/
                return accountDisplayList;
            }

            //CR00369463 sort by endDate newest first
            var sortElectionList= function(electionList){
                electionList.sort(function(electionA,electionB){
                    var date1 = new Date(electionA.endDate);
                    var date2 = new Date(electionB.endDate);
                    return date.compare(date2, date1, "date");
                });
                return electionList;
            }
            var sortAccountsForDisplay =function(accountDisplayList){
                accountDisplayList.sort(function(a, b) {f
                    var one = parseFloat(a.displaySeq);
                    var two = parseFloat(b.displaySeq);
                    if (one > two) return 1;
                    if (one < two) return -1;
                    return 0;
                });
                return accountDisplayList;
            }

            $scope.submitNewClaimBtn =function(){
               // storage.set("previousPageFromClaimBtn", "spendingAccount");
                storage.set("getClient", "claim");
               // router.go("#/clientListSelection");
            };

        }])

};